import styled from 'styled-components';
import device from '../mediaQueries';

const SizeGuideLabelWrapper = styled.div`
  ${device.mobile`
    text-align: right;
    user-select: none;
    outline: none;
    margin: 8% 5%;
  `}
`;

const SizeGuideLabel = styled.a`
  height: 17px;
  padding-left: 5px;
  font-size: 13px;
  line-height: 17px;
  color: #000000;
  text-decoration: underline;
  cursor: pointer;
`;

export { SizeGuideLabel, SizeGuideLabelWrapper };
